import React from "react";
import { node } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import CustomData from "pages/_components/CustomData/CustomData";

const EndososEcheck = ({ data }) => (
    <GridTable.Container columns={3} columnsTemplate="fixed">
        <GridTable.Data>
            <GridTable.Container>
                <GridTable.Data>
                    <CustomData
                        titleText="echecks.endorse.dateTime"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={data?.fecha_hora} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.endorse.endorseType"
                    titleTextType="I18N"
                    valueText={`echecks.endorse.types.${[data?.tipo_endoso]}`}
                    valueTextType="I18N"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.endorse.beneficiary"
                    titleTextType="I18N"
                    valueText={
                        data?.benef_documento_tipo ? `${data?.benef_documento_tipo} ${data?.benef_documento}` : "N/A"
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.endorse.issuer"
                    titleTextType="I18N"
                    valueText={
                        data?.emisor_documento_tipo ? `${data?.emisor_documento_tipo} ${data?.emisor_documento}` : "N/A"
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.endorse.state"
                    titleTextType="I18N"
                    valueText={data?.estado_endoso ? data?.estado_endoso : "NA"}
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
    </GridTable.Container>
);

EndososEcheck.propTypes = {
    data: node.isRequired,
};

export default EndososEcheck;
